import React from 'react';

const PHONE_DISPLAY = '07436 117842';
const PHONE_TEL = '+447436117842';

const TopBar = () => (
  <>
    <style>{`
      .usl-topbar {
        min-height: 40px;
        padding: 8px 5%;
        box-sizing: border-box;
        background: #001F3D;
        color: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-size: 0.85rem;
        font-weight: 600;
        line-height: 1.45;
      }

      .usl-topbar a {
        color: #FFFFFF;
        text-decoration: none;
        font-weight: 700;
      }

      .topbar-message-mobile {
        display: none;
      }

      @media (max-width: 768px) {
        .usl-topbar {
          min-height: 0;
          padding: 6px 12px;
          font-size: 12px;
          line-height: 1.35;
        }

        .topbar-message-desktop {
          display: none;
        }

        .topbar-message-mobile {
          display: inline;
        }
      }
    `}</style>

    <div className="usl-topbar">
      <span className="topbar-message-desktop">
        We&apos;ll Match Any Quote! Found it cheaper? Send it to us
        and we&apos;ll beat or match it.{' '}
        <a href={`tel:${PHONE_TEL}`}>{PHONE_DISPLAY}</a>.
        {' '}Book now pay later options available.
      </span>

      <span className="topbar-message-mobile">
        Found a cheaper quote? We&apos;ll match it! Call{' '}
        <a href={`tel:${PHONE_TEL}`}>{PHONE_DISPLAY}</a>.
      </span>
    </div>
  </>
);

export default TopBar;
